/**
 * Mesajlaşmanın kabuğa tek giriş noktası: anlık olaylar, adres parametresi ve panel.
 * Sohbet yetkisi (Kullanıcılar ekranındaki "Sohbet") yoksa hiçbir şey yapılmaz.
 */
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { useAuthStore } from '@/entities/session/model/authStore';
import { useChatStore } from '../model/chatStore';
import { useChatRealtime } from '../model/useChatRealtime';
import { ChatPanel } from './ChatPanel';

export function ChatHost() {
  const canUseChat = useAuthStore((s) => s.status === 'authenticated' && !!s.user?.canUseChat);
  const open = useChatStore((s) => s.open);
  useChatRealtime(canUseChat);
  const [params, setParams] = useSearchParams();

  // Push bildirimi / bağlantı: ?chat=u:<id> ya da g:<id> konuşmayı açar.
  const chatParam = params.get('chat');
  useEffect(() => {
    if (!chatParam || !canUseChat) return;
    if (/^[ug]:[0-9a-f-]{36}$/i.test(chatParam)) {
      useChatStore.getState().setOpen(true);
      useChatStore.getState().openConversation(chatParam);
    }
    const next = new URLSearchParams(params);
    next.delete('chat');
    setParams(next, { replace: true });
  }, [chatParam, canUseChat, params, setParams]);

  if (!canUseChat || !open) return null;
  return <ChatPanel />;
}
